import Layout from '../views/layout/Layout'

export default {
  path: '/repo',
  component: Layout,
  redirect: 'noredirect',
  name: 'repo',
  meta: {
    title: '素材存储库',
    elicon: 'el-icon-fa-database',
    roles: [],
  },
  children: [
    {
      path: 'basic',
      name: 'repo.basic',
      component: () => import('@/views/repository/base-package'),
      meta: {
        title: '基础素材包管理',
        roles: ['material.basic.list'],
      },
    },
    {
      path: 'case',
      name: 'repo.case',
      component: () => import('@/views/repository/case/index'),
      meta: {
        title: '案例库',
        roles: ['material.case.list'],
      },
    },
    {
      path: 'itav-material',
      name: 'repo.itav-material',
      redirect: 'itav-material/model-list',
      component: () => import('@/views/repository/material/index'),
      meta: {
        title: '交互素材资源库',
        roles: [],
      },
      hiddenChildren: true,
      children: [
        {
          path: 'model-list',
          name: 'repo.itav-material.model-list',
          component: () => import('@/views/repository/material/list'),
          meta: {
            title: '模型库',
            roles: ['res_store.list'],
          },
        },
        {
          path: 'model',
          name: 'repo.itav-material.model',
          component: () => import('@/views/repository/material/model/index'),
          meta: {
            title: '模型库',
            roles: [],
            className: 'highlight',
          },
          children: [
            {
              path: 'add',
              name: 'repo.itav-material.model.add',
              component: () =>
                import('@/views/repository/material/model/modelHandle'),
              meta: {
                title: '导入',
                roles: ['res_store.create'],
              },
            },
            {
              path: 'edit/:id(\\d+)',
              name: 'repo.itav-material.model.edit',
              component: () =>
                import('@/views/repository/material/model/modelHandle'),
              meta: {
                title: '编辑',
                roles: ['res_store.update'],
              },
            },
            {
              path: 'info/:id(\\d+)',
              name: 'repo.itav-material.model.detail',
              component: () =>
                import('@/views/repository/material/model/modelInfo'),
              meta: {
                title: '详情',
                roles: ['res_store.info'],
              },
            },
          ],
        },
        {
          path: 'action-list',
          name: 'repo.itav-material.action-list',
          component: () => import('@/views/repository/material/list'),
          meta: {
            title: '动作库',
            roles: ['res_store.list'],
          },
        },
        {
          path: 'action',
          name: 'repo.itav-material.action',
          component: () => import('@/views/repository/material/action/index'),
          meta: {
            title: '动作库',
            roles: [],
            className: 'highlight',
          },
          hiddenChildren: true,
          children: [
            {
              path: 'add',
              name: 'repo.itav-material.action.add',
              component: () =>
                import('@/views/repository/material/action/actionHandle'),
              meta: {
                title: '导入动作',
                roles: ['res_store.create'],
              },
              hidden: true,
            },
            {
              path: 'edit/:id(\\d+)',
              name: 'repo.itav-material.action.edit',
              component: () =>
                import('@/views/repository/material/action/actionHandle'),
              meta: {
                title: '编辑动作',
                roles: ['res_store.update'],
              },
              hidden: true,
            },
            {
              path: 'info/:id(\\d+)',
              name: 'repo.itav-material.action.detail',
              component: () =>
                import('@/views/repository/material/action/actionInfo'),
              meta: {
                title: '动作详情',
                roles: ['res_store.info'],
              },
              hidden: true,
            },
          ],
        },
        {
          path: '2d-animation-list',
          name: 'repo.itav-material.2d-animation-list',
          component: () => import('@/views/repository/material/list'),
          meta: {
            title: '2D动画库',
            roles: ['res_store.list'],
          },
        },
        {
          path: '2dAnimation',
          component: () =>
            import('@/views/repository/material/2dAnimation/index'),
          name: 'repo.itav-material.2d-animation',
          meta: {
            title: '2D动画库',
            roles: [],
            className: 'highlight',
          },
          children: [
            {
              path: 'add',
              component: () =>
                import('@/views/repository/material/2dAnimation/edit'),
              name: 'repo.itav-material.2d-animation.add',
              meta: {
                title: '导入',
                roles: ['res_store.create'],
              },
            },
            {
              path: 'edit/:id(\\d+)',
              name: 'repo.itav-material.2d-animation.edit',
              component: () =>
                import('@/views/repository/material/2dAnimation/edit'),
              meta: {
                title: '编辑',
                roles: ['res_store.update'],
              },
            },
            {
              path: 'detail/:id(\\d+)',
              name: 'repo.itav-material.2d-animation.detail',
              component: () =>
                import('@/views/repository/material/2dAnimation/detail'),
              meta: {
                title: '详情',
                roles: ['res_store.info'],
              },
            },
          ],
        },
        {
          path: '2d-effect-list',
          name: 'repo.itav-material.2d-effect-list',
          component: () => import('@/views/repository/material/list'),
          meta: {
            title: '2D特效库',
            roles: ['res_store.list'],
          },
        },
        {
          path: 'audio-list',
          name: 'repo.itav-material.audio-list',
          component: () => import('@/views/repository/material/list'),
          meta: {
            title: '背景音乐库',
            roles: ['res_store.list'],
          },
        },
        {
          path: 'hand-list',
          name: 'repo.itav-material.hand-list',
          component: () => import('@/views/repository/material/list'),
          meta: {
            title: '手指库',
            roles: ['res_store.list'],
          },
        },
        {
          path: 'background-list',
          name: 'repo.itav-material.background-list',
          component: () => import('@/views/repository/material/list'),
          meta: {
            title: '背景图库',
            roles: ['res_store.list'],
          },
        },
        {
          path: 'sequence-frame-list',
          name: 'repo.itav-material.sequence-frame-list',
          component: () => import('@/views/repository/material/list'),
          meta: {
            title: '特效库',
            roles: ['res_store.list'],
          },
        },
        {
          path: 'button-skin-list',
          name: 'repo.itav-material.button-skin-list',
          component: () => import('@/views/repository/material/list'),
          meta: {
            // title: '按钮皮肤库',
            title: 'CTA按钮',
            roles: ['res_store.list'],
          },
        },
        {
          path: 'lead-role-list',
          name: 'repo.itav-material.lead-role-list',
          component: () => import('@/views/repository/material/list'),
          meta: {
            title: '主角库',
            roles: ['res_store.list'],
          },
        },
        {
          path: 'font-list',
          name: 'repo.itav-material.font-list',
          component: () => import('@/views/repository/material/list'),
          meta: {
            title: '字体库',
            roles: ['res_store.list'],
          },
        },
        {
          path: 'dialog-list',
          name: 'repo.itav-material.dialog-list',
          component: () => import('@/views/repository/material/list'),
          meta: {
            title: '对话框',
            roles: ['res_store.list'],
          },
        },
        {
          path: 'progress-bar-list',
          name: 'repo.itav-material.progress-bar-list',
          component: () => import('@/views/repository/material/list'),
          meta: {
            title: '进度条',
            roles: ['res_store.list'],
          },
        },
        {
          path: 'music-list',
          name: 'repo.itav-material.music-list',
          component: () => import('@/views/repository/material/list'),
          meta: {
            title: '音效库',
            roles: ['res_store.list'],
          },
        },
        {
          path: 'animation-preset-list',
          name: 'repo.itav-material.animation-preset-list',
          component: () => import('@/views/repository/material/list'),
          meta: {
            title: '动画预设',
            roles: ['res_store.list'],
          },
        },
      ],
    },
    {
      path: 'non-itav-material',
      name: 'repo.non-itav-material',
      redirect: 'non-itav-material/slogan',
      component: () => import('@/views/repository/material/nonItavIndex'),
      meta: {
        title: '非交互素材资源库',
        roles: [],
      },
      hiddenChildren: true,
      children: [
        {
          path: 'slogan',
          component: () => import('@/views/repository/material/slogan/index'),
          meta: {
            title: '文案库',
            roles: ['res_store.list2'],
          },
        },
        {
          path: 'picture',
          component: () => import('@/views/repository/material/picture/index'),
          meta: {
            title: '图片库',
            roles: ['res_store.list2'],
          },
        },
        {
          path: 'video',
          component: () => import('@/views/repository/material/video/index'),
          meta: {
            title: '视频库',
            roles: ['res_store.list2'],
          },
        },
        {
          path: 'audio',
          component: () => import('@/views/repository/material/audio/index'),
          meta: {
            title: '音乐库',
            roles: ['res_store.list2'],
          },
        },
        {
          path: 'font',
          component: () => import('@/views/repository/material/font/index'),
          meta: {
            title: '字体库',
            roles: ['res_store.list2'],
          },
        },
      ],
    },
    {
      path: 'public-resource',
      name: 'repo.public-resource',
      component: () => import('@/views/repository/resource/index'),
      meta: {
        title: '公共资源管理',
        roles: ['asset.list'],
      },
    },
    {
      path: 'material-label',
      name: 'repo.material-label',
      component: () => import('@/views/repository/labels/index'),
      meta: {
        title: '素材标签管理',
        roles: ['tag.list'],
      },
    },
  ],
}
